<template>
  <v-dialog v-model="showDialog" scrollable max-width="530px">
    <v-card>
      <v-card-title>Test Customise</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="customise" style="height: 530px;">
        <section class="subject my-3" v-for="(subject, index) in customiseJson" v-bind:key="index">
          <h2 class="text-xs-center">{{subject.title}}</h2>
          <div v-if="subject.duplicate">
            <el-row :gutter="4" v-if="subject.imageSize=='small'">
              <el-col :span="8" v-for="(item, j) in subject.items" v-bind:key="j">
                <div class="grid-content bg-purple">
                  <div class="choice pa-3 ma-2">{{item.name}}</div>
                  <div class="text-xs-center clearfix">
                    <el-button
                      type="danger"
                      size="mini"
                      circle
                      @click="onQuantityChanged('reduce', subject, item)"
                    >
                      <i class="fas fa-minus"></i>
                    </el-button>
                    <span class="quantity">{{item.quantity}}</span>
                    <el-button
                      type="success"
                      size="mini"
                      circle
                      @click="onQuantityChanged('add', subject, item)"
                    >
                      <i class="fas fa-plus"></i>
                    </el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="4" v-if="subject.imageSize=='none'">
              <el-col
                :span="24"
                v-for="(item, j) in subject.items"
                v-bind:key="j"
                class="list-wrapper"
              >
                <label class="label">{{item.name}}</label>
                <div class="right-label">
                  <div class="text-xs-center clearfix">
                    <el-button
                      type="danger"
                      size="mini"
                      circle
                      @click="onQuantityChanged('reduce', subject, item)"
                    >
                      <i class="fas fa-minus"></i>
                    </el-button>
                    <span class="quantity">{{item.quantity}}</span>
                    <el-button
                      type="success"
                      size="mini"
                      circle
                      @click="onQuantityChanged('add', subject, item)"
                    >
                      <i class="fas fa-plus"></i>
                    </el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div v-if="!subject.duplicate">
            <el-row :gutter="4" v-if="subject.imageSize=='small'">
              <el-col :span="8" v-for="(item, j) in subject.items" v-bind:key="j">
                <div>
                  <div
                    class="choice pa-3 ma-2"
                    v-bind:class="{ 'checked': item.checked }"
                    @click="onSelected(subject, item)"
                  >{{item.name}}</div>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="4" v-if="subject.imageSize=='none'">
              <el-col
                :span="24"
                v-for="(item, j) in subject.items"
                v-bind:key="j"
                class="list-wrapper"
              >
                <label class="label">
                  <strong>{{item.name}}</strong>
                  <br>
                  <span v-if="item.price>0">+{{item.price}} THB</span>
                </label>
                <div class="right-label text-xs-right">
                  <input
                    type="radio"
                    v-model="subject.id"
                    :value="item.id"
                    v-on:change="onSelected(subject, item)"
                  >
                  <br>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="mt-3">Validation : {{subject.isValid}}</div>
        </section>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click="showDialog = false">Close</v-btn>
        <v-btn color="blue darken-1" flat @click="onDoneClicked">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "customise-dialog",
  props: ["dialog", "customise_json"],
  data() {
    return {
      radio: 1111
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      }
    },
    customiseJson: {
      get() {
        if (this.customise_json.length >= 1) {
          this.customise_json.map((subject, x) => {
            if (subject.duplicate) {
              this.customise_json[x].items = subject.items.map((item, y) => {
                return { ...item, quantity: 0 };
              });
            } else {
              this.customise_json[x].items = subject.items.map((item, y) => {
                return { ...item, checked: false };
              });
            }
          });
          return this.customise_json;
        }
      },
      set(value) {
        if (!value) {
        }
      }
    }
  },
  mounted() {},
  methods: {
    onSelected(subject, item) {
      let subjectIndex = this.customise_json.findIndex(
        x => x.id === subject.id
      );
      let min = this.customise_json[subjectIndex].min;
      let max = this.customise_json[subjectIndex].max;

      let itemIndex = this.customise_json[subjectIndex].items.findIndex(
        x => x.id === item.id
      );

      if (!this.customise_json[subjectIndex].items[itemIndex].checked) {
        let countChecked = this.getChecked(
          this.customise_json[subjectIndex].items
        );
        if (countChecked >= max) {
          alert("cannot check more item");
          return;
        }
      }

      this.customise_json[subjectIndex].items[itemIndex].checked = !this
        .customise_json[subjectIndex].items[itemIndex].checked;

      let countChecked = this.getChecked(
        this.customise_json[subjectIndex].items
      );

      if (countChecked >= min && countChecked <= max) {
        this.customise_json[subjectIndex].isValid = true;
      } else {
        this.customise_json[subjectIndex].isValid = false;
      }
    },
    onQuantityChanged(type, subject, item) {
      let subjectIndex = this.customise_json.findIndex(
        x => x.id === subject.id
      );
      let min = this.customise_json[subjectIndex].min;
      let max = this.customise_json[subjectIndex].max;
      let itemIndex = this.customise_json[subjectIndex].items.findIndex(
        x => x.id === item.id
      );

      let countQty = this.getQuantity(this.customise_json[subjectIndex].items);

      if (type == "add") {
        if (countQty >= max) {
          alert("cannot add more item");
          return;
        }
        if (this.customise_json[subjectIndex].items[itemIndex].quantity < 15) {
          this.customise_json[subjectIndex].items[itemIndex].quantity++;
        }
      } else if (type == "reduce") {
        if (this.customise_json[subjectIndex].items[itemIndex].quantity > 0) {
          this.customise_json[subjectIndex].items[itemIndex].quantity--;
        }
      }

      countQty = this.getQuantity(this.customise_json[subjectIndex].items);
      if (countQty >= min && countQty <= max) {
        this.customise_json[subjectIndex].isValid = true;
      } else {
        this.customise_json[subjectIndex].isValid = false;
      }
    },
    getChecked(arr) {
      let length = 0;
      arr.map(item => {
        if (item.checked == true) {
          length++;
        }
      });
      return length;
    },
    getQuantity(arr) {
      let quantity = 0;
      arr.map(item => {
        quantity += item.quantity;
      });
      return quantity;
    },
    onDoneClicked() {
      console.log(JSON.stringify(this.customise_json));
      this.$emit("done");
    }
  }
};
</script>

<style lang="scss">
.customise {
  .subject {
    border-bottom: 2px solid #eee;
    margin: 12px 0;
    padding: 10px 0;
  }

  .quantity {
    display: inline-block;
    margin: 0 8px;
    width: 32px;
  }

  .choice {
    border: 1px solid #b0bec5;
    background-color: #cfd8dc;
    border-radius: 4px;
    text-align: center;

    &.checked {
      background-color: #546e7a;

      &:hover {
        background-color: #546e7a;
        cursor: pointer;
      }
    }

    &:hover {
      background-color: #b0bec5;
      cursor: pointer;
    }
  }
}

.list-wrapper {
  position: relative;
  padding: 9px 0;
  border-bottom: 1px solid #eee;
  height: 60px;

  .label {
    position: absolute;
    left: 2px;
  }

  .right-label {
    float: right;
    padding-right: 12px;
  }
}
</style>
